<template>
    <div class="videoPlayer">
        <video 
            :controls="false"
            :muted="muted"
            class="video"
            id="video"
            ref="player">
            <source :src="src">
        </video>

        <div class="videoPlayer__controls" :class="{ 'pause': !playing }">
            <img v-if="muted" @click="muted = !muted" class="videoPlayer__controls__muteBtn" src="/img/default/volume-mute.svg" alt="">
            <img v-else @click="muted = !muted" class="videoPlayer__controls__muteBtn" src="/img/default/volume-sound.svg" alt="">

            <div class="videoPlayer__controls__container">
                <div class="videoPlayer__controls__container__bar left">
                    <div class="videoPlayer__controls__container__bar__value" :style="{ 'width': `${percentage}%` }"></div>
                </div>
                
                <img class="videoPlayer__controls__container__playBtn" @click="togglePlaying" v-if="playing" src="/img/default/pause-btn.svg" alt="">
                <img class="videoPlayer__controls__container__playBtn" @click="togglePlaying" v-else src="/img/default/play-btn.svg" alt="">
                
                <div class="videoPlayer__controls__container__bar right">
                    <div class="videoPlayer__controls__container__bar__value" :style="{ 'width': `${percentage}%` }"></div>
                </div>

            </div>

            <div class="videoPlayer__controls__info">
                {{ curMinutes }}:{{ curSeconds }}/{{ durationMinutes }}:{{ durationSeconds }}
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss" src="./style.scss"></style>

<script src="./script.js"></script>
